const endpoint = property => `/api/${ property }/events/periods`;
const pricingendpoint = (property, id) => `${endpoint(property)}/${id}/pricing`;

export default ['api', '$rootScope', function(api, $rootScope) {
  return {
    save: period => {
      let url = period.id ? `${ endpoint(api.property()) }/${ period.id }` : endpoint(api.property());

      return api.upload(url, period).then(response => response.data);
    },
    savePricing: period => {
      let url = period.id ? `${ pricingendpoint(api.property(), period.id) }` : pricingendpoint(api.property(), 0);

      return api.post(url, period).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint(api.property()) }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint(api.property())+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint(api.property()) }/${ id }`)
        .then(response => response.data);
    },
    toggleActive: id => {
      return api.get(`${ endpoint(api.property()) }/status/${ id }`)
        .then(response => response.data);
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint(api.property()) }?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    },
    updateList: periods => api.get(`${ endpoint(api.property()) }/priority/${periods}`).then(response => response)
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/services/periods.service.js